// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__37rCk","dragIcon":"SortableItem_dragIcon__1-TGd","disabled":"SortableItem_disabled__1k9yA"};